import { render, staticRenderFns } from "./Study_plan_request_form.vue?vue&type=template&id=39c05f40"
import script from "./Study_plan_request_form.vue?vue&type=script&lang=js"
export * from "./Study_plan_request_form.vue?vue&type=script&lang=js"
import style0 from "./Study_plan_request_form.vue?vue&type=style&index=0&id=39c05f40&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports